import { createRouter, createWebHistory } from 'vue-router'
// import PromptTestFlow from '../components/promptTest/PromptTestFlow.vue' // Test 1 disabled
import PromptTest2Flow from '../components/promptTest2/PromptTest2Flow.vue'
import PromptTestDashboard from '../components/PromptTestDashboard.vue'
import RegisterForm from '../components/RegisterForm.vue'
// import ChatInterface from '../components/ChatInterface.vue' // Temporarily disabled
import UserDashboard from '../components/UserDashboard.vue'
import UserDetailView from '../components/UserDetailView.vue'
import AdminAuth from '../components/AdminAuth.vue'
import PromptsView from '../components/PromptsView.vue'
import AstroLifePrompts from '../components/AstroLifePrompts.vue'
import SuggestionsManagement from '../components/SuggestionsManagement.vue'
import FeedbackDashboard from '../components/FeedbackDashboard.vue'
import FeedbackDetailView from '../components/FeedbackDetailView.vue'
import ReportDashboard from '../components/ReportDashboard.vue'
import ReportDetailView from '../components/ReportDetailView.vue'
import ThumbDashboard from '../components/ThumbDashboard.vue'
import ThumbDetailView from '../components/ThumbDetailView.vue'
import ContentFeedbackDashboard from '../components/ContentFeedbackDashboard.vue'
import TranscriptionsDashboard from '../components/TranscriptionsDashboard.vue'
import AiUsageDashboard from '../components/AiUsageDashboard.vue'
import HoroscopePodcastDashboard from '../components/HoroscopePodcastDashboard.vue'
import ClientLogsDashboard from '../components/ClientLogsDashboard.vue'
import ClientLogDetailView from '../components/ClientLogDetailView.vue'
import NotificationDashboard from '../components/NotificationDashboard.vue'
import AdaptyWebhookDashboard from '../components/AdaptyWebhookDashboard.vue'
import SubscriptionCancellersDashboard from '../components/SubscriptionCancellersDashboard.vue'
import EmailRepliesDashboard from '../components/EmailRepliesDashboard.vue'
import EmailReplyDetailView from '../components/EmailReplyDetailView.vue'
import SocialHooksDashboard from '../components/SocialHooksDashboard.vue'
import PlaybooksDashboard from '../components/PlaybooksDashboard.vue'
import VerifyDashboard from '../components/VerifyDashboard.vue'
import VerifyCheckPage from '../components/VerifyCheckPage.vue'
import SystemLogsDashboard from '../components/SystemLogsDashboard.vue'
import SystemLogDetailView from '../components/SystemLogDetailView.vue'
import ExportDashboard from '../components/ExportDashboard.vue'
import SignalsDashboard from '../components/SignalsDashboard.vue'
import IntentLogDetailView from '../components/IntentLogDetailView.vue'
import AICommentDashboard from '../components/AICommentDashboard.vue'
import StyleProfilesDashboard from '../components/StyleProfilesDashboard.vue'
import YearAheadReportsDashboard from '../components/YearAheadReportsDashboard.vue'
import NatalChartReportsDashboard from '../components/NatalChartReportsDashboard.vue'
import CompatibilityReportsDashboard from '../components/CompatibilityReportsDashboard.vue'
import CelebrityTwinsReportsDashboard from '../components/CelebrityTwinsReportsDashboard.vue'
import TwinFiguresDashboard from '../components/TwinFiguresDashboard.vue'
import AstrocartographyReportsDashboard from '../components/AstrocartographyReportsDashboard.vue'
import CityPoolDashboard from '../components/CityPoolDashboard.vue'
import BirthChartPreview from '../components/BirthChartPreview.vue'

const getAdminAuthCookie = () => {
  const cookies = document.cookie.split(';')
  const adminCookie = cookies.find(cookie => cookie.trim().startsWith('adminAuth='))
  return adminCookie ? adminCookie.split('=')[1].trim() : null
}

const routes = [
  {
    path: '/chat-test',
    name: 'promptTest',
    component: PromptTest2Flow
  },
  // {
  //   path: '/chat-test-old',
  //   name: 'promptTestOld',
  //   component: PromptTestFlow
  // },
  {
    path: '/',
    name: 'home',
    component: RegisterForm
  },
  // Chat route temporarily disabled
  // {
  //   path: '/chat',
  //   name: 'chat',
  //   component: ChatInterface
  // },
  {
    path: '/admin',
    name: 'admin',
    component: AdminAuth
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: UserDashboard,
    meta: { requiresAdmin: true }
  },
  {
    path: '/user/:id',
    name: 'userDetail',
    component: UserDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/feedbacks',
    name: 'feedbacks',
    component: FeedbackDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/feedback/:id',
    name: 'feedbackDetail',
    component: FeedbackDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/reports',
    name: 'reports',
    component: ReportDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/report/:id',
    name: 'reportDetail',
    component: ReportDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/prompts',
    name: 'prompts',
    component: PromptsView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/prompt-tests',
    name: 'promptTests',
    component: PromptTestDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/astro-life-prompts',
    name: 'AstroLifePrompts',
    component: AstroLifePrompts,
    meta: { requiresAuth: true }
  },
  {
    path: '/suggestions',
    name: 'suggestions',
    component: SuggestionsManagement,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/thumbs',
    name: 'thumbs',
    component: ThumbDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/thumb/:id',
    name: 'thumbDetail',
    component: ThumbDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/content-feedback',
    name: 'ContentFeedbackDashboard',
    component: ContentFeedbackDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/ai-usage',
    name: 'AiUsageDashboard',
    component: AiUsageDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/transcriptions',
    name: 'TranscriptionsDashboard',
    component: TranscriptionsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/horoscope-podcast',
    name: 'HoroscopePodcastDashboard',
    component: HoroscopePodcastDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/client-logs',
    name: 'ClientLogsDashboard',
    component: ClientLogsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/client-log/:id',
    name: 'ClientLogDetailView',
    component: ClientLogDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to,from,next)=>{
      const has=getAdminAuthCookie();if(has) next(); else next('/admin')
    }
  },
  {
    path: '/adapty-webhooks',
    name: 'AdaptyWebhookDashboard',
    component: AdaptyWebhookDashboard
  },
  {
    path: '/subscription-cancellers',
    name: 'SubscriptionCancellersDashboard',
    component: SubscriptionCancellersDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/email-replies',
    name: 'EmailRepliesDashboard',
    component: EmailRepliesDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/email-reply/:id',
    name: 'EmailReplyDetailView',
    component: EmailReplyDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/social-hooks',
    name: 'SocialHooksDashboard',
    component: SocialHooksDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/playbooks',
    name: 'PlaybooksDashboard',
    component: PlaybooksDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/verify-checks',
    name: 'VerifyDashboard',
    component: VerifyDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/account/activate/:uuid',
    name: 'AccountActivate',
    component: VerifyCheckPage
  },
  {
    path: '/verify/:uuid',
    name: 'VerifyCheckPage',
    component: VerifyCheckPage
  },
  {
    path: '/system-logs',
    name: 'SystemLogsDashboard',
    component: SystemLogsDashboard
  },
  {
    path: '/system-log/:id',
    name: 'SystemLogDetailView',
    component: SystemLogDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/export',
    name: 'ExportDashboard',
    component: ExportDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/signals',
    name: 'signals',
    component: SignalsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    // Intent classifier retired; the old dashboard now lives as an archive tab
    // inside Signals. Keep the path working via redirect.
    path: '/intent-logs',
    redirect: '/signals'
  },
  {
    path: '/intent-log/:id',
    name: 'intentLogDetail',
    component: IntentLogDetailView,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/ai-comments',
    name: 'AICommentDashboard',
    component: AICommentDashboard
  },
  {
    path: '/style-profiles',
    name: 'StyleProfilesDashboard',
    component: StyleProfilesDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/year-ahead',
    name: 'YearAheadReportsDashboard',
    component: YearAheadReportsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/natal-chart',
    name: 'NatalChartReportsDashboard',
    component: NatalChartReportsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/compatibility',
    name: 'CompatibilityReportsDashboard',
    component: CompatibilityReportsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/celebrity-twins',
    name: 'CelebrityTwinsReportsDashboard',
    component: CelebrityTwinsReportsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/twin-figures',
    name: 'TwinFiguresDashboard',
    component: TwinFiguresDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/astrocartography',
    name: 'AstrocartographyReportsDashboard',
    component: AstrocartographyReportsDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/cities',
    name: 'CityPoolDashboard',
    component: CityPoolDashboard,
    meta: { requiresAdmin: true },
    beforeEnter: (to, from, next) => {
      const hasAdminAuth = getAdminAuthCookie()
      if (hasAdminAuth) {
        next()
      } else {
        next('/admin')
      }
    }
  },
  {
    path: '/birth-chart',
    name: 'BirthChartPreview',
    component: BirthChartPreview
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    const hasAdminAuth = getAdminAuthCookie()
    if (!hasAdminAuth) {
      next('/admin')
      return
    }
  }
  next()
})

export default router 